import { useCallback, useEffect, useState } from 'react';

interface HatchbackPaintSVGProps {
  view: 'left' | 'top' | 'right';
  className?: string;
  onLoad?: () => void;
}

/**
 * Komponent SVG hatchbacka dla widoku punktów pomiarowych lakieru
 *
 * Dynamicznie importuje odpowiedni plik SVG na podstawie widoku:
 * - left: svg/hatchback-left.svg
 * - top: svg/all-center.svg (wspólny dla wszystkich typów)
 * - right: svg/hatchback-right.svg
 */
export const HatchbackPaintSVG: React.FC<HatchbackPaintSVGProps> = ({
  view,
  className = '',
  onLoad,
}) => {
  const [IconComponent, setIconComponent] = useState<React.FC<React.SVGProps<SVGSVGElement>> | null>(null);

  const getSvgName = useCallback(() => {
    switch (view) {
      case 'left':
        return 'hatchback-left';
      case 'top':
        return 'all-center';
      case 'right':
        return 'hatchback-right';
      default:
        return 'hatchback-left';
    }
  }, [view]);

  const importIcon = useCallback(async () => {
    try {
      const svgName = getSvgName();
      /* @vite-ignore */
      const imported = await import(`./svg/${svgName}.svg`);
      setIconComponent(() => imported.ReactComponent);
    } catch (error) {
      console.error('Błąd ładowania SVG hatchbacka:', error);
    }
  }, [getSvgName]);

  useEffect(() => {
    importIcon();
  }, [importIcon]);

  useEffect(() => {
    if (IconComponent) {
      onLoad?.();
    }
  }, [IconComponent, onLoad]);

  if (!IconComponent) {
    return <div className={className} />;
  }

  return <IconComponent className={className} />;
};
